import config from '../../config.json'

/**
 * Returns true if the current host matches the student site.
 * @return {boolean}
 */
export function isOnStudentSite() {
  return location.host === config.studentSiteDomain
}

/**
 * Returns true if the current host matches the teacher site.
 * @return {boolean}
 */
export function isOnTeacherSite() {
  return location.host === config.teacherSiteDomain
}
